import { STATUS_INIT } from 'constants/statuses.constants';

export const getInitialState = () => ({
  construct: {},
  status: STATUS_INIT,
  error: null,
});
